/* eslint-disable guard-for-in,no-restricted-syntax */
import translator from 'bazinga-translator';
import translationsLanguages from '../translations';

translator.fallback = 'en';
translator.defaultDomain = 'general';

for (const translationsLanguage in translationsLanguages) {
  const translations = translationsLanguages[translationsLanguage];

  for (const translationDomain in translations) {
    for (const translationKey in translations[translationDomain]) {
      translator.add(
        translationKey,
        translations[translationDomain][translationKey],
        'general',
        translationsLanguage,
      );
    }
  }
}

export default translator;
